module.exports = __webpack_public_path__ + "static/media/TileAcc.80fbc088.png";